var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDialog',{attrs:{"title":_vm.title,"max-width":"50vw"},scopedSlots:_vm._u([{key:"information",fn:function(){return [_c('Logs',{attrs:{"logs":_vm.logsArray}})]},proxy:true}]),model:{value:(_vm.showLogsDialog),callback:function ($$v) {_vm.showLogsDialog=$$v},expression:"showLogsDialog"}})
}
var staticRenderFns = []

export { render, staticRenderFns }